module.exports = __webpack_public_path__ + "img/de71e4f1523b4138a4fe28d1f4ab38c5_mergeImage.f9514bca.png";